module.exports = __webpack_public_path__ + "img/zz7.641ec10f.png";